export function getCurrentEnvironment():
  | "local"
  | "development"
  | "staging"
  | "production" {
  if (import.meta.env.VITE_API_URL.includes("localhost")) {
    return "local";
  }

  if (import.meta.env.VITE_API_URL.includes("dev")) {
    return "development";
  }

  if (import.meta.env.VITE_API_URL.includes("stag")) {
    return "staging";
  }

  return "production";
}
